<template>
    <div class="carlist_wrapper city_letter_wrapper">
        <!--品牌-->
        <div class="series_wrapper">
            <div class="header_wrapper">
                <b class="left_title">选择城市</b>
            </div>
            <div class="out_main_wrapper">
                <div class="main_wrapper_series">
                    <div class="left_firstseries" ref="left_firstseries">
                        <van-field v-model="search_city" placeholder="请输入所在地区" class="search_ipt" @input="onSearch">
                            <van-button v-if="!isShowSearch" slot="button" size="small">
                                搜索
                            </van-button>
                            <van-button v-if="isShowSearch" slot="button" size="small" @click="cancelSearch">
                                取消
                            </van-button>
                        </van-field>
                        <!--列表-->
                        <div class="series_list_wrapper" @scroll="handleScroll()" ref="series_list_wrapper">
                            <template v-for="(citys, idx) in city">
                                <div :key="idx">
                                    <div v-if="idx != 0 && citys.letter != city[idx - 1].letter || idx == 0"
                                        class="hot_title series_tilte character" :id="citys.letter">{{ citys.letter }}
                                    </div>
                                    <ul class="series_list">
                                        <li class="series_list_item" @click="clk_city(citys)">
                                            {{ citys.city }}
                                        </li>
                                    </ul>
                                </div>
                            </template>

                            <!-- 空白提示 -->
                            <div class="series_list_empty" v-if="city.length == 0">
                                <img src="../assets/image/empty.png" alt="空白提示">
                                <p>暂无城市</p>
                            </div>
                        </div>
                    </div>
                    <!--右侧-->
                    <div class="right_letters">
                        <!-- <ul> -->
                        <ul v-if="city.length == city_list.length">
                            <li v-for="(item, index) in letter" :key="index" @click="to_letter(index, item)"
                                :class="activeLetter == item ? 'cur' : ''">{{ item }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import lib_requirement from "@/libs/lib_requirement";

export default {
    props: {
        activity_id: { type: Number, default: 0 }, //项目id
        custom_car: { type: Number, default: 0 }, //是否自定义车型库
        is_dialog_city: { type: Boolean, default: false }
    },

    data() {
        return {
            hot: [], //热门车型
            city: [], // 展示的城市列表
            city_list: [], // 原始数据
            letter: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'], //右侧ABC
            series_list: [], //车型
            city_id: undefined, //品牌id
            city_name: '', //品牌name
            currIndex: 0,
            activeLetter: 'A',
            is_active: false, //获取点击字母

            search_city: '', //搜索城市

            current_city: {},

            city_show: false,
            isShowSearch: false,
        };
    },
    created() {
        let that = this;
        lib_requirement.atbcity(function (data) {
            that.city_list = data;
            that.city = data;
            that.activeLetter = data[0].letter;
        })
        this.$nextTick(() => {
            window.addEventListener('scroll', () => {
                this.handleScroll()
            }, true)
        })
    },
    mounted() {

    },
    destroyed() {
        window.removeEventListener('scroll', () => {
            this.handleScroll()
        }, true)
    },
    methods: {
        //字母
        to_letter(index, item) {
            this.is_active = index;
            this.currIndex = index;
            this.activeLetter = item;
            document.querySelector('#' + this.activeLetter).scrollIntoView({
                behavior: 'smooth'
            })
        },
        onSearch() {
            let that = this;
            if (that.search_city.trim() != '') {
                this.isShowSearch = true;
                that.city = that.city_list.filter(item => {
                    if (item.city.includes(that.search_city)) {
                        that.activeLetter = item.letter;
                    }
                    return item.city.includes(that.search_city)
                })
            } else {
                this.search_city = '';
                this.isShowSearch = false;
                this.city = this.city_list;
            }
        },
        cancelSearch() {
            this.search_city = '';
            this.isShowSearch = false;
            this.city = this.city_list;
        },
        // 滚动
        handleScroll() {
            let leftEle = [...document.querySelectorAll('.character')];
            let leftWrapper = this.$refs.series_list_wrapper;
            let leftHotHeight = this.$refs.left_firstseries?.scrollTop;
            leftEle.forEach((item, index) => {
                if (item.offsetTop < leftWrapper.offsetTop + leftHotHeight - 30) {
                    this.activeLetter = item.innerText
                }
            })
        },
        //选择城市
        clk_city(item) {
            // this.is_dialog_city = false;
            this.$emit("query", item.city, item.brand_list);
        },

        // others methods
        closePopup() {
            this.$emit('handleClose', false)
        },
    },
    watch: {
        is_dialog_city(v) {
            // this.search_city = '';
        },
    }
};
</script>

<style lang="less">
@import "../assets/style/carList/carlist_noimg.less";

.city_letter_wrapper {
    .series_list_wrapper {
        height: 100%;
    }

    .search_ipt {
        padding: 8px 8px 8px 24px;
        margin: 0 0 20px 0;
        border-radius: 10px;
        background-color: #fff;
        border: 1px solid #e5e5e5;
    }

    .van-button--default {
        border: none;
        font-size: 28px;
    }

    .series_list_empty {
        text-align: center;
        font-size: 28px;
        color: #89939F;

        img {
            width: 260px;
            height: auto;
            margin-top: 150px;
            margin-bottom: 20px;
        }
    }
}
</style>
